const trackingCardVars = [
    'contPlayState',
    'eventEndCardSelect',
    'endCardContentList',
    'endCardContentPosition',
    'endCardCountdownTime',
    'endCardContentSelection',
    'endCardSource',
    'endCardType',
    'endCardTimerTotal',
    'endCardTriggerType',
    'endCardRecommendationSource',
    'endCardRecommendationContext',
    'endCardSourceContentId',
    'endCardRecommendedContentIdList',
    'endCardSourceType',
    'endCardContentListCount',
    'endCardContentListType',
    'midCardTriggerType',
    'midCardRecommendationSource',
    'midCardSourceContentId',
    'midCardSourceType',
    'midCardSource',
    'midCardContentList',
    'midCardRecommendedContentIdList',
    'midCardContentListType',
    'midCardContentListCount',
    'midCardType',
    'midCardTimerTotal',
    'midCardCountdownTime',
    'midCardContentPosition',
    'midCardContentSelection',
];

const trackingVarsKeys = [
    ...trackingCardVars,
    'liveTvChannel',
    'currentListingTitle',
    'stationCode',
    'ctaText',
    'nextVideoRecommendationSource',
    'nextVideoRecommendedContent',
    'nextVideoRecommendedContentId',
    'nextVideoSource',
    'nextVideoSourceContentId',
    'nextVideoSourceType',
];

const saveSessionEndcardData = (objMediaTrackingMetadata) => {
    let storage = JSON.parse(localStorage.getItem('cbs_cp')) || {};
    storage.cp = {};
    Object.keys(objMediaTrackingMetadata).forEach((key) => {
        if (trackingVarsKeys.includes(key)) {
            storage.cp[key] = objMediaTrackingMetadata[key];
        }
    });
    localStorage.setItem('cbs_cp', JSON.stringify(storage));
    document.cookie = 'CBS_CP=1;path=/';
};

const clearCardsDataFromUtag = () => {
    if (window.utag_data) {
        trackingCardVars.forEach((key) => {
            if (key in window.utag_data) {
                delete window.utag_data[key];
            }
        });
    }
};

export { clearCardsDataFromUtag, saveSessionEndcardData };
